import { TerminalButton, TerminalButton2 } from "@/components/buttons/Buttons"
import { useState } from "react";

export default function CreatePaymentInstrumentForm({
    onSubmit,
    onClear,
    onCancel
}: {
    onSubmit: (form: {
        type: string;
        accountName: string;
        accountNumber: string;
        routingNumber: string;
        isDefault: boolean;
    }) => void,
    onClear?: Function,
    onCancel?: Function
}) {
    const [accountName, setAccountName] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [routingNumber, setRoutingNumber] = useState("");
    const [isDefault, setIsDefault] = useState(true);

    return (
        <div className="mt-3 rounded-lg border border-gray-200 bg-gray-50/50 p-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">Account Name</label>
                    <input
                        type="text"
                        value={accountName}
                        onChange={(e) => setAccountName(e.target.value)}
                        placeholder="Enter account name"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Account Number</label>
                    <input
                        type="text"
                        value={accountNumber}
                        onChange={(e) => setAccountNumber(e.target.value)}
                        placeholder="Enter account number"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Routing Number</label>
                    <input
                        type="text"
                        value={routingNumber}
                        onChange={(e) => setRoutingNumber(e.target.value)}
                        placeholder="Enter routing number"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    />
                </div>
                <div className="md:col-span-2 flex items-center gap-2">
                    <input
                        id="isDefaultPaymentInstrument"
                        type="checkbox"
                        checked={isDefault}
                        onChange={(e) => setIsDefault(e.target.checked)}
                        className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    />
                    <label htmlFor="isDefaultPaymentInstrument" className="text-sm text-gray-700">
                        Set as default payment method
                    </label>
                </div>
            </div>
            <div className="mt-2">
                <TerminalButton processing={false} onClick={() => onSubmit({
                    type: "bank_account",
                    accountName,
                    accountNumber,
                    routingNumber,
                    isDefault
                })}>
                    Save
                </TerminalButton>
                <TerminalButton2
                    onClick={() => {
                        onClear?.()
                        setAccountName("");
                        setAccountNumber("");
                        setRoutingNumber("");
                        setIsDefault(true);
                        onCancel?.();
                    }}
                >
                    Cancel
                </TerminalButton2>
            </div>
        </div>
    )
}
